/**
 * @fileoverview Sidebar footer component providing external link icon buttons
 * for pgAdmin, GitHub, and Sentry.
 */

import { Stack } from '@mui/material';
import { BiLogoGithub, BiLogoPostgresql } from 'react-icons/bi';
import { SiSentry } from "react-icons/si";
import { TooltipIconButton } from '@/shared/components/TooltipIconButton';

function SidebarFooter() {
  function handlePgAdminNavigate() {
    window.open('https://toolpad.keithwalsh.eu/pgadmin4/', '_blank');
  }

  function handleGitHubNavigate() {
    window.open('https://github.com/keithwalsh/toolpad', '_blank');
  }

  function handleSentryNavigate() {
    window.open('https://sentry.io/organizations/keithwalsh/projects/toolpad/', '_blank');
  }

  return (
    <Stack
      direction="row"
      spacing={0.5}
      sx={{
        p: 1,
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <TooltipIconButton
        tooltip="pgAdmin"
        aria-label="open pgAdmin"
        onClick={handlePgAdminNavigate}
      >
        <BiLogoPostgresql size={22} />
      </TooltipIconButton>
      <TooltipIconButton
        tooltip="GitHub"
        aria-label="open GitHub repository"
        onClick={handleGitHubNavigate}
      >
        <BiLogoGithub size={22} />
      </TooltipIconButton>
      <TooltipIconButton
        tooltip="Sentry"
        aria-label="open Sentry"
        onClick={handleSentryNavigate}
      >
        <SiSentry size={20} />
      </TooltipIconButton>
    </Stack>
  );
}

export { SidebarFooter };
